export default {
    parts: [
        'drawerContent',
        'drawerHeader',
        'headerRow',
        'headerTitle',
        'viewBagButton',
        'drawerCloseButton',
        'drawerBodyWithItems',
        'drawerBodyEmpty',
        'productListWrap',
        'drawerFooter',
        'footerStack'
    ],
    baseStyle: (props) => ({
        drawerContent: {
            marginTop: 0,
            color: 'webTypo.textPrimary'
        },
        drawerHeader: {
            boxShadow: 'none',
            p: '16px !important',
            position: 'relative',
            borderBottom: '1px solid',
            borderColor: 'gray.50'
        },
        headerRow: {
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row'
        },
        headerTitle: {
            textStyle: 'webH2'
        },
        drawerCloseButton: {
            alignSelf: 'end',
            marginLeft: '5',
            width: '5',
            position: 'static',
            _hover: {}
        },
        drawerBodyWithItems: {
            padding: 4,
            overflowX: 'hidden'
        },
        drawerBodyEmpty: {
            padding: {base: 4, lg: 6},
            pr: {lg: 6},
            overflowX: 'hidden'
        },
        productListWrap: {
            flexDirection: 'column',
            gap: 5
        },
        drawerFooter: {
            p: '16px !important',
            borderTop: props.hasCMSAccordion ? '1px solid' : 0,
            borderColor: 'webTheme.strokeDefault',
            position: 'relative',
            color: 'webTypo.textPrimary'
        },
        footerStack: {
            width: '100%',
            flex: '1',
            gap: 0
        }
    })
}
